import { render } from "./AuthenticationError.vue?vue&type=template&id=f7f87b50&ts=true"
import script from "./AuthenticationError.vue?vue&type=script&lang=ts"
export * from "./AuthenticationError.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__